module.exports = __webpack_public_path__ + "static/media/Pump and Cassette replacement for pH Controller - 10mls.be035a45.webp";